export default {
  findByIdOrSlug (collection, id) {
    let item

    if ((item = collection.getById(id))) {
      return item
    } else if ((item = collection.getAll({ slug: id }).first())) {
      return item
    } else {
      return collection.getAll({ legacy_id: parseInt(id) }).first()
    }
  }
}
